import * as actions from './actions';

export default function(state = null, action) {
  switch (action.type) {

  case actions.SET_STAGE:
    return action.stage;

  default:
    return state;
  }
}
